export const toggleNone = className => {
  let elements = document.getElementsByClassName(className)
  for (let i = 0; i < elements.length; i++) {
    if (elements[i].style.display === "none") {
      elements[i].style.display = "";
    } else {
      elements[i].style.display = "none";
    }
  }
}
// toggleNone('Damage-A'); // toggles remove

export const toggleVisibility = className => {
  let elements = document.getElementsByClassName(className)
  for (let i = 0; i < elements.length; i++) {
    let elements = document.getElementsByClassName(className);
    if (elements[i].style.visibility === "hidden") {
      elements[i].style.visibility = "";
    } else {
      elements[i].style.visibility = "hidden";
    }
  }
}
// toggleVisibility('Damage-A'); // toggles hide
// see my stack overflow post about this
// https://stackoverflow.com/questions/11254429/hiding-all-elements-with-the-same-class-name/61782275#61782275